import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { ServiceBasicInformationPageStore } from './services-basic-information-page.store';
import {
    ServiceBasicInfoComponent,
} from '../../../components/services/service-basic-info/service-basic-info.component';
import {
    WorkplaceTableComponent,
} from '../../../components/services/workplace/workplaces-table/workplace-table.component';
import {
    ServiceDataShareComponent,
} from '../../../components/services/service-data-share/service-data-share.component';

@Component({
    selector: 'app-service-basic-information-page',
    templateUrl: 'services-basic-information-page.component.html',
    styleUrls: ['services-basic-information-page.component.scss'],
    providers: [ServiceBasicInformationPageStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ServiceBasicInfoComponent,
        WorkplaceTableComponent,
        ServiceDataShareComponent,
    ],
})
export class ServicesBasicInformationPageComponent extends SubscriptionComponent {
    protected readonly store = inject(ServiceBasicInformationPageStore);


}
